import { Modal } from 'antd'
import classNames from 'classnames'
import { type FormEvent, type ReactNode, useState } from 'react'

import AtomButton from '@/components/Atoms/AtomButton/AtomButton'
import { useScrollEdges } from '@/hooks/ui/useScrollEdges'
import { useUserInfoStore } from '@/stores/user/userInfoStore'

import cn from './AtomModalWithForm.module.scss'

const MODAL_WIDTH = 520

type AtomModalWithFormProps = {
  title: string
  open: boolean
  submitting: boolean
  onCancel: () => void
  onSubmit: (event: FormEvent<HTMLFormElement>) => void
  children: ReactNode
  submitText?: string
  submitDisabled?: boolean
  width?: number | string
  headerAction?: ReactNode
  maskClosable?: boolean
  footer?: ReactNode
  beforeFields?: ReactNode
}

function AtomModalWithForm({
  title,
  open,
  submitting,
  onCancel,
  onSubmit,
  children,
  submitText = 'Создать',
  submitDisabled = false,
  width = MODAL_WIDTH,
  headerAction,
  maskClosable = true,
  footer,
  beforeFields,
}: AtomModalWithFormProps) {
  const isOrganisationSelected = useUserInfoStore(
    (state) => Object.keys(state.selectedOrganisation).length > 0
  )
  const [fieldsElement, setFieldsElement] = useState<HTMLDivElement | null>(
    null
  )
  const { hasContentAbove, hasContentBelow } = useScrollEdges(fieldsElement)

  return (
    <Modal
      centered
      destroyOnHidden
      open={open}
      width={width}
      footer={null}
      onCancel={onCancel}
      maskClosable={maskClosable && !submitting}
      closable={!submitting}
      className={classNames(
        cn.modal,
        isOrganisationSelected && cn.organisationSelected
      )}
    >
      <form className={cn.form} onSubmit={onSubmit} noValidate>
        <h2 className={cn.title}>{title}</h2>
        <div className={cn.hintRow}>
          <p className={cn.hint}>
            <span className={cn.hintMark}>*</span> обязательные поля
          </p>
          {headerAction}
        </div>
        {beforeFields}
        <div
          className={classNames(
            cn.fieldsFrame,
            hasContentAbove && cn.fadeTop,
            hasContentBelow && cn.fadeBottom
          )}
        >
          <div ref={setFieldsElement} className={cn.fields}>
            <div className={cn.fieldsContent}>{children}</div>
          </div>
        </div>
        {footer ? (
          <div className={cn.customFooter}>{footer}</div>
        ) : (
          <div className={cn.footer}>
            <AtomButton
              variant="secondary"
              fullWidth
              disabled={submitting}
              onClick={onCancel}
            >
              Отмена
            </AtomButton>
            <AtomButton
              htmlType="submit"
              fullWidth
              loading={submitting}
              disabled={submitDisabled}
            >
              {submitText}
            </AtomButton>
          </div>
        )}
      </form>
    </Modal>
  )
}

export default AtomModalWithForm
